module.exports = __webpack_public_path__ + "img/icn-select-24-px-little.303f173b.svg";